import CiiCurrentData from "./data";

export default function mapCiiCurrentDataFromJson(json) {
    return new CiiCurrentData(
        json['current_cii'],
        json['current_cii_no_effect'],
        json['current_cii_no_fouling'],
        json['current_cii_no_wind'],
        json['start_time']
    )
}
